export default __webpack_public_path__ + "static/media/clairefontaine12.bc6f802c.jpg";